export default {
  SET_STORE (state, { charityId, store }) {
    state.stores[charityId] = store;
  },
  SET_CLIENT_TOKEN (state, { charityId, tokenData }) {
    state.clientTokens[charityId] = tokenData;
  },
  REMOVE_CLIENT_TOKEN (state, charityId ) {
    delete state.clientTokens[charityId];
  },
  SET_EVENTS (state, events) {
    state.events = events
    state.eventsLoading = false;
    state.lastUpdate = parseInt((new Date().getTime() / 1000));
  },
  SET_TICKETS (state, tickets) {
    state.tickets.push(...tickets);
  },
  CLEAR_TICKETS (state) {
    state.tickets = [];
  },
  LOADING_EVENTS (state) {
    state.eventsLoading = true
  }
}
